import {
    FetchState,
    SsoValidationState,
    CognitoTokens
} from "@/shared/types";
import { CognitoAuth as Auth } from "@/shared/api/auth";
import * as UserService from "@/shared/api/userService";
import { defineStore } from "pinia";
import _ from "lodash";
import { useUserStore } from "@/shared/store/user";
import { useRootStore } from "@/shared/store/root";

export const initialState: SsoValidationState = {
    fetchState: FetchState.Uninitialized,
    cognitoTokens: null,
    error: false,
    isLogoutLoginMode: false
};


export const useSsoStore = defineStore("sso", {
    state: (): SsoValidationState => (_.cloneDeep(initialState)),
    getters: {
        isLoading: state => state.fetchState !== FetchState.Loaded,
        loginFailed: state => state.fetchState === FetchState.Loaded && state.error,
        isLoggingIn: state => state.isLogoutLoginMode
    },
    actions: {
        setCognitoTokens (cognitoTokens: CognitoTokens) {
            this.cognitoTokens = { ...cognitoTokens };
        },
        setFetchState (fetchState: FetchState) {
            this.fetchState = fetchState;
        },
        setErrorState (error: boolean) {
            this.error = error;
        },
        setIsLogoutLoginMode (mode: boolean) {
            this.isLogoutLoginMode = mode;
        },
        resetSsoState () {
            this.error = false;
            this.cognitoTokens = null;
            this.isLogoutLoginMode = false;
        },
        validateSsoAccount (token: string): Promise<void> {
            if (this.fetchState === FetchState.Loading) {
                return Promise.resolve();
            }

            this.resetSsoState();
            this.setFetchState(FetchState.Loading);
            const userStore = useUserStore();

            if (userStore.loggedIn) {
                const rootState = useRootStore();
                rootState.resetState();
                this.setIsLogoutLoginMode(true);
            }

            return UserService.ssoValidateAccount(token)
                .then(result => {
                    userStore.activeUserPing();
                    // trigger login call from here
                    const { username, email, accessToken, idToken, refreshToken } = result.data;
                    Auth.setSignInUserSession(username, accessToken, idToken, refreshToken)
                        .then(user => userStore.processLogin({ ...user, email } as any))
                        .then(_ => this.setFetchState(FetchState.Loaded))
                        .then(_ => this.setIsLogoutLoginMode(false));
                })
                .catch(error => {
                    this.setFetchState(FetchState.Loaded);
                    this.setErrorState(true);
                });
        }
    }
});